module.exports = __webpack_public_path__ + "img/rg_old.dbe4446a.png";